import { DateEdit } from "../../../../../UI.BaseControls/DateEdit";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { YEAR_CHECK_REGEXP, YEAR_WITH_MONTH_CHECK_REGEXP } from "../FilterShared";

export class FilterDateEdit extends DateEdit {
    protected get _testUserValue(): boolean {
        return YEAR_CHECK_REGEXP.test(this.userValue) || YEAR_WITH_MONTH_CHECK_REGEXP.test(this.userValue);
    }

    public override validate(): boolean {
        if (this._testUserValue) {
            this.setValid();

            return true;
        } else {
            return super.validate();
        }
    }

    public override parseAndValidateUserInput(triggerEvent: boolean): void {
        if (!this._testUserValue) {
            super.parseAndValidateUserInput(triggerEvent);
        }
    }

    protected override _listenerFocus(): void {
        if (this._testUserValue) return;
        if (this.enabled && this.validate())
            this._innerElement.value = DateEdit._formatDate(this._fakeInput.value); // zformatuje v aktualni kulture
    }
}

registerCustomElement("tsc-FilterDateEdit", FilterDateEdit);
